import type { AssetType } from '@cartwhl/common/api/getAssets';
import type { FilesListFile } from '@cartwhl/ui/input/FilesList';

import type { AssetLibraryMediaSelection } from '../AssetLibrary/assetLibraryMediaSelection';
import type { MascotReferenceFilledItem } from './components/MascotReferenceFilledPanel';

export function buildSingleReferenceItems(input: {
  librarySelection: AssetLibraryMediaSelection | null;
  assetType: AssetType;
  onRemoveLibrary: () => void;
  localFile?: FilesListFile;
  onRemoveLocal?: (fileId: string) => void;
}): MascotReferenceFilledItem[] {
  if (input.librarySelection) {
    return [
      {
        id: input.librarySelection.mediaID,
        thumbnailUrl: input.librarySelection.thumbnailURL ?? '',
        assetType: input.assetType,
        onRemove: input.onRemoveLibrary,
      },
    ];
  }

  if (!input.localFile || !input.onRemoveLocal) {
    return [];
  }

  return [
    {
      id: input.localFile.id,
      thumbnailUrl: input.localFile.objectUrl,
      assetType: input.assetType,
      onRemove: () => input.onRemoveLocal?.(input.localFile!.id),
    },
  ];
}

export function buildMultiReferenceItems(input: {
  librarySelections: AssetLibraryMediaSelection[];
  assetType: AssetType;
  onRemoveLibrary: (mediaID: string) => void;
  localFiles: FilesListFile[];
  onRemoveLocal: (fileId: string) => void;
}): MascotReferenceFilledItem[] {
  const items: MascotReferenceFilledItem[] = input.librarySelections.map(
    (selection) => ({
      id: selection.mediaID,
      thumbnailUrl: selection.thumbnailURL ?? '',
      assetType: input.assetType,
      onRemove: () => input.onRemoveLibrary(selection.mediaID),
    }),
  );

  for (const file of input.localFiles) {
    items.push({
      id: file.id,
      thumbnailUrl: file.objectUrl,
      assetType: input.assetType,
      onRemove: () => input.onRemoveLocal(file.id),
    });
  }

  return items;
}
